module.exports = __webpack_public_path__ + "static/media/M1-16-Yazaroth-cod115-B.b87f05d6.png";